<template>
    <v-card>
      <v-toolbar flat>
        <span class="headline">To Corrector</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="hideDialog">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-layout class="status-option-layout" v-if="isShowPushStatusBtn(loan.loanStatus)">
        <v-radio-group v-model="targetOptionData.targetStatus" class="status-option-radio">
          <v-flex lg6>
            <v-radio
              v-if="isShowElement(authorization.privileges, dataType.PrivilegeCode.AUDITED_TO_AGENT_REVIEW_OPTION, dataType.PrivilegeType.EXECUTABLE)"
              color="primary"
              :label="targetOptionData.agentReviewOption.label"
              :value="targetOptionData.agentReviewOption.status"
              class="reason-text"
            ></v-radio>
          </v-flex>
          <v-flex lg6>
            <v-radio
              v-if="isShowElement(authorization.privileges, dataType.PrivilegeCode.AUDITED_TO_CORRECTOR_REVIEW_OPTION, dataType.PrivilegeType.EXECUTABLE)"
              color="primary"
              :label="targetOptionData.correctorReviewOption.label"
              :value="targetOptionData.correctorReviewOption.status"
              class="reason-text"
            ></v-radio>
          </v-flex>
        </v-radio-group>
      </v-layout>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="updateLoanStatus" :loading="loading">Save</v-btn>
      </v-card-actions>
    </v-card>
</template>

<script>
import { DataType, Popup, Tool, Authentication } from '@/util/index'
import { OriginationBusinessApi } from '@/api/pandaria'

const popup = new Popup()
const tool = new Tool()
export default {
  name: 'to-corrector-dialog',
  components: {},
  props: {
    loan: Object,
    authorization: Object
  },
  data () {
    return {
      dataType: DataType,
      dataSource: [],
      loading: false,
      targetOptionData: {
        targetStatus: null,
        agentReviewOption: {
          status: DataType.LoanStatus.AGENT_REVIEW.value,
          label: 'To Agent Review'
        },
        correctorReviewOption: {
          status: DataType.LoanStatus.CORRECTOR_REVIEW.value,
          label: 'To Corrector Review'
        }
      }
    }
  },
  computed: {
    loanId () {
      return this.loan.id
    }
  },
  methods: {
    hideDialog () {
      this.dataSource = []
      this.$emit('hideDialog', 'TO_CORRECTOR')
    },
    judgeData () {
      const $this = this
      let result = true
      const tableData = $this.dataSource
      const lastOne = tableData.length - 1
      if (tool.isNotEmpty(tableData)) {
        if (Object.keys(tableData[lastOne]).length !== 3) {
          popup.popupForWarning('Correction Reason or Notes is required')
          result = false
        }
      }
      return result
    },
    updateLoanStatus () {
      const $this = this
      let status
      if ($this.loan.loanStatus === DataType.LoanStatus.TRIBE_REVIEW.value) {
        status = DataType.LoanStatus.CORRECTOR_REVIEW.value
      } else {
        status = this.targetOptionData.targetStatus
      }
      if (tool.isEmpty(status)) {
        this.$swal({ type: 'warning', text: 'Please select the target status', showCancelButton: false })
        return
      }
      if ($this.judgeData()) {
        $this.loading = true
        const request = {
          loanId: $this.loan.id,
          status: status
        }
        OriginationBusinessApi.changeLoanStatus(request, function () {
          $this.$eventBus.$emit('updateStatus', { status })
          $this.$eventBus.$emit('refreshVerifyStamp')
          $this.$eventBus.$emit('forceUnlock', { unlockReason: DataType.UnlockLoanReasonEnum.STATUS_CHANGED.value })
          popup.popupForSuccess('Operation is successful')
          $this.hideDialog()
          $this.loading = false
        }, function (result) {
          popup.popupForWarning(result.message)
          $this.loading = false
        })
      }
    },
    isShowPushStatusBtn (loanStatus) {
      return loanStatus !== DataType.LoanStatus.TRIBE_REVIEW.value
    },
    isShowElement (privileges, code, value) {
      return Authentication.matchElementPrivilege(privileges, code, value)
    }
  }
}
</script>

<style>
  .v-textarea textarea {
    resize: none;
  }
  .status-option-layout {
    margin-left: 30px;
  }
  .status-option-radio {
    width: 500px;
  }
</style>
